import React from "react"
import PropTypes from "prop-types"

import USD from "../../../components/usd"
import CustomButton from "./custom-button"
import PriceButton from "./price-button"
import { Carousel } from 'react-responsive-carousel'

class PriceButtons extends React.Component {

  renderPriceItems() {
    const {currentPrice, presetPrices, onChangePrice} = this.props
    return presetPrices.map((price, i) =>
      <PriceButton key={i} selected={price === currentPrice} number={price} onClick={onChangePrice} >
        ${price}
      </PriceButton>
    )
  }

  renderPlayerPriceItems() {
    const {
      currentPlayersNumber, priceMultiplier, presetPlayersNumbers, selectedReservation, onChangePlayersNumber
    } = this.props
    const {totalPrice} = selectedReservation || {}
    return presetPlayersNumbers.map((n, i) =>
      <PriceButton key={i} selected={n === currentPlayersNumber} number={n} onClick={onChangePlayersNumber}
        unitsNumber={priceMultiplier}
      >
        <div>{n} Players</div>
        {totalPrice && <USD className="price-value" val={totalPrice / n} />}
      </PriceButton>
    )
  }

  render() {
    const {buttonsPosition, onChangePlayersNumber, onChangePrice, onChangeButtonsPosition} = this.props
    return (
      <div className="price-buttons-container">
        <Carousel
          showThumbs={false}
          showArrows={false}
          showStatus={false}
          swipeable={true}
          emulateTouch={true}
        >
          <div className="price-buttons">
            {this.renderPriceItems()}
            <CustomButton onChange={onChangePrice} />
          </div>
          <div>
            <div className="player-price-buttons">
              {this.renderPlayerPriceItems()}
              <CustomButton onChange={onChangePlayersNumber} />
            </div>
          </div>
        </Carousel>
      </div>
    )
  }
}

PriceButtons.propTypes = {
  buttonsPosition: PropTypes.number,
  currentPlayersNumber: PropTypes.number,
  currentPrice: PropTypes.number,
  presetPlayersNumbers: PropTypes.arrayOf(PropTypes.number).isRequired,
  presetPrices: PropTypes.arrayOf(PropTypes.number).isRequired,
  priceMultiplier: PropTypes.number.isRequired,
  selectedReservation: PropTypes.object,
  onChangeButtonsPosition: PropTypes.func.isRequired,
  onChangePrice: PropTypes.func.isRequired,
  onChangePlayersNumber: PropTypes.func.isRequired,
}

export default PriceButtons
